if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // We tell Shopify to return the updated HTML for your cart icon
        formData.append('sections', 'cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
        
        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }
        
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Handle errors (like out of stock)
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            }

            // 1. UPDATE THE CART BUBBLE (The little number)
            const cartIconBubble = document.getElementById('cart-icon-bubble');
            if (cartIconBubble && response.sections['cart-icon-bubble']) {
              cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
            }

            // 2. SHOW FEEDBACK ON THE BUTTON
            const submitButtonSpan = this.submitButton.querySelector('span');
            const originalText = submitButtonSpan.textContent;
            // submitButtonSpan.textContent = "Adicionado! ✅";
            submitButtonSpan.textContent = "✓";

            // Reset button after 2 seconds
            setTimeout(() => {
              submitButtonSpan.textContent = originalText;
            }, 2000);

            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
